// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-header {
  height: 72px;
  padding: 0 24px;
  border-bottom: 1px solid #e5e7eb;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-header h2 {
  margin: 0;
  color: #1d4ed8;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.2;
}

.modal-header p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 13px;
}

.modal-header-danger h2 {
  color: #dc2626;
}

.modal-close {
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 12px;
  background: #f8fafc;
  color: #334155;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: all 0.18s ease;
}

.modal-close:hover {
  background: #fee2e2;
  color: #dc2626;
}

.modal-close mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/negar/negar.page.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ;;AAEE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AACJ;;AAEE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEE;EACE,cAAA;AACJ;;AAEE;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;AACJ;;AAEE;EACE,mBAAA;EACA,cAAA;AACJ;;AAEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AACJ","sourcesContent":[".modal-header {\n    height: 72px;\n    padding: 0 24px;\n    border-bottom: 1px solid #e5e7eb;\n    background: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  \n  .modal-header h2 {\n    margin: 0;\n    color: #1d4ed8;\n    font-size: 20px;\n    font-weight: 800;\n    line-height: 1.2;\n  }\n  \n  .modal-header p {\n    margin: 4px 0 0;\n    color: #64748b;\n    font-size: 13px;\n  }\n  \n  .modal-header-danger h2 {\n    color: #dc2626;\n  }\n  \n  .modal-close {\n    width: 40px;\n    height: 40px;\n    border: 0;\n    border-radius: 12px;\n    background: #f8fafc;\n    color: #334155;\n    display: grid;\n    place-items: center;\n    cursor: pointer;\n    transition: all 0.18s ease;\n  }\n  \n  .modal-close:hover {\n    background: #fee2e2;\n    color: #dc2626;\n  }\n  \n  .modal-close mat-icon {\n    font-size: 22px;\n    width: 22px;\n    height: 22px;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
